import { showToast } from './toasts.js';

const bookmarks = window.__GLOBAL_STATE__ && window.__GLOBAL_STATE__.bookmarks;
const bookmarkUrl = window.__GLOBAL_STATE__ && window.__GLOBAL_STATE__.bookmarkUrl;
const profileId = window.__GLOBAL_STATE__ && window.__GLOBAL_STATE__.profile;
const loginUrl = window.__GLOBAL_STATE__ && window.__GLOBAL_STATE__.loginUrl;
const registerUrl = window.__GLOBAL_STATE__ && window.__GLOBAL_STATE__.registerUrl;
let bookmarkRequestLock = false;
let csrfToken = null;

const bookmarkButtonClass = 'BookmarkButton';
const bookmarkButtonActiveClass = 'BookmarkButton--active';
const bookmarkButtonIndeterminateClass = 'BookmarkButton--indeterminate';
const bookmarkHiddenClass = 'Bookmark--hidden';

function initializeBookmarkButton(button) {
  const id = parseInt(button.dataset.id, 10);
  const type = button.dataset.type;

  const REMOVE_BOOKMARK = 0;
  const ADD_BOOKMARK = 1;

  button.addEventListener('click', () => {
    if (!profileId) {
      showLoginRequiredAlert(type);
      return;
    }
    const action = bookmarks[type] && bookmarks[type].includes(id) ? REMOVE_BOOKMARK : ADD_BOOKMARK;
    const payload = { id, bookmark: action, field: type };

    const response = sendBookmarkRequest(payload);
    if (response) {
      response.then(response => {
        if (response.status !== 200) {
          return;
        }
        if (action === ADD_BOOKMARK) {
          if (!bookmarks[type]) {
            bookmarks[type] = [];
          }
          bookmarks[type].push(id);
          showToast(`You've saved this ${type}.`, {
            iconUrl: '/static/images/ic-check-circle-dark.svg'
          });
        } else if (action === REMOVE_BOOKMARK) {
          if (bookmarks[type]) {
            const index = bookmarks[type].indexOf(id);
            if (index >= 0) {
              bookmarks[type].splice(index, 1);
            }
          }
        }
        setBookmarkButtonState(button);
      })
      .catch(error => console.warn('Bookmark request failed.', error));
    }
  });
}

function setBookmarkButtonState(button) {
  const id = parseInt(button.dataset.id, 10);
  const type = button.dataset.type;
  if (bookmarks[type] && bookmarks[type].includes(id)) {
    button.classList.add(bookmarkButtonActiveClass);
    button.textContent = button.dataset.removeLabel;
    button.dataset.tooltip = button.dataset.removeLabel
  } else {
    button.classList.remove(bookmarkButtonActiveClass);
    button.textContent = button.dataset.addLabel;
    button.dataset.tooltip = button.dataset.addLabel;
  }
  button.classList.remove(bookmarkButtonIndeterminateClass);
}

function sendBookmarkRequest(payload) {
  if (bookmarkRequestLock) {
    return null;
  }
  bookmarkRequestLock = true;

  const data = new FormData();
  for (const key in payload) {
    data.append(key, payload[key]);
  }

  return fetch(bookmarkUrl, {
    method: 'POST',
    mode: 'same-origin',
    headers: {
      'X-CSRFToken': csrfToken
    },
    body: data
  }).then(response => {
    bookmarkRequestLock = false;
    return response;
  }).catch(error => {
    bookmarkRequestLock = false;
    throw error;
  });
}

function showLoginRequiredAlert(type) {
  let message = `Sorry, you cannot bookmark the ${type} at the moment.`;
  const currentUrl = window.location.pathname + window.location.search;
  if (loginUrl || registerUrl) {
    message = `Please `;
    let loginUrlWithRedirect = loginUrl;
    if (loginUrlWithRedirect) {
      loginUrlWithRedirect += `?next=${currentUrl}`
    }
    let registerUrlWithRedirect = registerUrl;
    if (registerUrlWithRedirect) {
      registerUrlWithRedirect += `?next=${currentUrl}`
    }
    if (loginUrlWithRedirect) {
      message += `<a href="${loginUrlWithRedirect}">sign in</a> `;
      if (registerUrlWithRedirect) {
        message += `or <a href="${registerUrlWithRedirect}">register</a> `;
      }
    } else {
      message += `<a href="${registerUrlWithRedirect}">register</a> `;
    }
    message += 'to access all features.';
  }
  showToast(message, {
    iconUrl: '/static/images/ic-alert-circle-dark.svg'
  });
}

export function initializeBookmarks() {

  if (!window.__GLOBAL_STATE__) {
    return;
  }

  csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
  if (!bookmarks || !bookmarkUrl) {
    return;
  }
  const bookmarkButtons = document.querySelectorAll(`.${bookmarkButtonClass}`);
  bookmarkButtons.forEach(button => {
    setBookmarkButtonState(button);
    initializeBookmarkButton(button);
  });

  const bookmarkHidden = document.querySelectorAll(`.${bookmarkHiddenClass}`);
  bookmarkHidden.forEach(element => element.classList.remove(bookmarkHiddenClass));
}
